export const fiveDigitRand = () => Math.floor(Math.random() * (99999 - 1) + 1);
